<template>
    <div id="question">
        <Header v-if="self.media" :media="updateMedia" :progress_questions="questions"/>
        <section>
            <h2>{{ self.question }}</h2>

            <ol v-if="!showExplanation" class="answers" :type="settings.list_type">
                <li v-for="(answer, a_index) in shuffleAnswers"
                    :key="a_index"
                    v-html="answer.text"
                    @click="handleAnswerClick($event, answer)"/>
            </ol>

            <Explanation v-if="showExplanation"
                         :button_colors="settings.button_colors"
                         :button="settings.skip_explanation"
                         :content="self.explanation"
                         @next="updateNext"/>
        </section>
    </div>
</template>

<script>
import Explanation from './Explanation.vue'
import Header from './Header.vue'

export default {
    name: 'Question',
    components: {
        Explanation,
        Header
    },
    props: ['self', 'settings', 'index', 'correct', 'questions'],
    data: function () {
        return {
            answers: [],
            explanatory: this.explanation,
            displayExplanation: false,
            correctAnswer: false,
            gameOver: false,
            active: true
        }
    },
    methods: {
        update() {
            this.$emit(this.action)
        },
        updateNext() {
            this.displayExplanation = false;
            this.endRound('next', this.correctAnswer, this.gameOver);
        },
        handleAnswerClick(event, answer) {
            let over = true;
            if ( ! this.active) return;

            if (this.index < (this.settings.rounds - 1)) over = false;
            this.gameOver = over;
            if (answer.correct) {
                this.correctAnswer = true;
                event.target.classList.add('correct');
            } else {
                this.correctAnswer = false;
                event.target.classList.add('false');
            }
            this.deactivateLi();
            this.explain(event);
        },
        explain(target) {
            setTimeout(() => {
                if (this.ifExplanation) this.displayExplanation = true;
                else this.endRound('next', this.correctAnswer, this.gameOver);
                this.resetLi(target);
            }, 420);
        },
        endRound(update, correct_answer, game_over) {
            this.$emit(update, correct_answer, game_over);
        },
        deactivateLi() {
            this.active = false;
        },
        resetLi(event) {
            event.target.classList.remove('correct', 'false');
            this.active = true;
        },
        shuffle(array) {
            let ctr = array.length, temp, index;
            while (ctr > 0) {
                index = Math.floor(Math.random() * ctr);
                ctr--;
                temp = array[ctr];
                array[ctr] = array[index];
                array[index] = temp;
            }
            return array;
        }
    },
    computed: {
        ifExplanation() {
            return Boolean(this.self.explanation?.text).valueOf();
        },
        showExplanation() {
            return this.displayExplanation;
        },
        updateMedia() {
            return this.self.media
        },
        shuffleAnswers() {
            return this.shuffle(this.self.answers)
        }
    }
}
</script>
